/* eslint-disable no-else-return */
/* global window */
import { get } from 'lodash';

export default () => {
	const currentTime = new Date().getTime();
	const lastTokenRequestTime = window.localStorage.getItem('access_token_request_time') || 0;
	// if older than 50 minutres, treat as expired
	const tokenExpired = !!(currentTime - lastTokenRequestTime > 3000000);

	if (!tokenExpired && window.localStorage.getItem('access_token')) {
		return Promise.resolve(true);
	} else if (get(window, 'mdPageActions.obtainToken')) {
		return window.mdPageActions.obtainToken().then(() => {
			window.localStorage.setItem('access_token_request_time', currentTime);
			return true;
		});
	} else if (window.localStorage.getItem('access_token')) {
		return Promise.resolve(true);
	}
	// eslint-disable-next-line no-console
	console.error('obtainToken() not found and no token found in storage');
	return Promise.reject();
};
